import { createApp } from 'vue'
import App from '@/App.vue'
import router from './router'
import store from './store'
import modalPlugin from './plugins/modalPlugin';
import DIRECTIVES from '@/directives';
import FILTERS from '@/filters';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@/css/transitions.css';
import '@/css/op-table.css';
import '@/css/style.css';
import 'swiper/css';

import { register } from 'swiper/element/bundle';
register();

// let root = document.documentElement;
// let finalHeight = root.clientHeight - (window.innerHeight - root.clientHeight);
// root.style.setProperty('--windowHeight', finalHeight + "px");

let root = document.documentElement;

if(window.innerWidth > 480){
    root.style.setProperty('--ondeBgPaddingTop', 306 + "px");
} else {
    // 984 : 505 = window.innerWidth : x;
    let ondePaddingTop = window.innerWidth * 505 / 984
    root.style.setProperty('--ondeBgPaddingTop', ondePaddingTop + "px");
}


//toastr
import 'toastr/build/toastr.min.css';
import toastr from 'toastr';

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 4000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};
window.toastr = toastr;

import moment from 'moment';
import { LocalizationServices } from './services/LocalizationServices';
moment.locale("IT-it");

import 'chartjs-adapter-moment';
import { CommonServices } from './services/CommonServices';
import { ModalServices } from './services/ModalServices';


const app = createApp(App)
    .use(store)
    .use(router)
    .use(modalPlugin);

for(let prop in DIRECTIVES){
    app.directive(prop, DIRECTIVES[prop])
}

app.config.globalProperties.$filters = FILTERS;
app.config.globalProperties.$localizationService = LocalizationServices;

const ComponentContext = require.context('./components', true, /\.vue$/i);
ComponentContext.keys().forEach(fileName => {
    var component = ComponentContext(fileName);
    let componentName = fileName.split('/').pop().split('.')[0];
    app.component(componentName, (<any>component).default || component);
})


CommonServices.showSpinnerCb = () => {
    store.state.showSpinner++;
}
CommonServices.hideSpinnerCb = () => {
    store.state.showSpinner--;
    if(store.state.showSpinner < 0){
        store.state.showSpinner = 0;
    }
}
CommonServices.unauthorizedCb = () => {
    if(router.currentRoute.value.path != '/')
        router.push('/?redirect=' + router.currentRoute.value.fullPath);
}
CommonServices.validationErrorsCb = (errors) => {
    ModalServices.validationErrorModal(errors);
}

function delegate(el, evt, sel, handler) {
    el.addEventListener(evt, function(event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
}

// delegate(window.document.body, "click", "a", (event) => {
//     if(event.target.target == '_blank'){
//         store.state.openBrowser(event);
//     }
// })

window.handleOpenURL = (url: string) => {
    // setTimeout(() => {
    //     let hashIndex = url.indexOf("#");
    //     if(hashIndex > -1){
    //         let navTo = url.substring(hashIndex + 1);
    //         router.push(navTo);
    //     }
    // }, 100)
}

function detectCordova() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'cordova.js';
        script.onload = () => {
            resolve(true); // Cordova è presente
        };
        script.onerror = () => {
            resolve(false); // Cordova NON è presente (404 o errore)
        };
        document.head.appendChild(script);
    });
}

detectCordova().then(isCordova => {

    const scriptMaps = document.createElement('script');
    scriptMaps.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDiUZxsehaN1bKCJZ4iSUK2jbJtxy5mXu8&libraries=places&region=IT&libraries=marker,places';
    scriptMaps.async = true;
    scriptMaps.defer = true;
    document.head.appendChild(scriptMaps);

    if (!isCordova) {
        const scriptGSI = document.createElement('script');
        scriptGSI.src = 'https://accounts.google.com/gsi/client';
        scriptGSI.async = true;
        scriptGSI.defer = true;
        document.head.appendChild(scriptGSI);
        
        const scriptAppleAuth = document.createElement('script');
        scriptAppleAuth.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        document.head.appendChild(scriptAppleAuth);
    }
    return isCordova;
})
.then(x => {
    app.mount('#app');
});
